export const LOCAL_STORAGE_ITEMS = {
  ORDER: 'order',
  USER: 'user',
  LAST_STEP: 'lastStep'
}
